// extracted by mini-css-extract-plugin
export default {"App":"Main_App__9l8nn","content":"Main_content__ae5Uz","BackgroundAnimation":"Main_BackgroundAnimation__ZjrQL"};